import {Injectable} from "@angular/core";
import {firstValueFrom} from "rxjs";
import {PerFormaAPIService, PTPStepDto} from "src/app/services/pfapi.service";

@Injectable({
    providedIn: "root"
})
export class PTPStepsService {
    private _initialized = false;
    private _steps: PTPStepDto[] = null;

    Steps = async () => {
        if (!this._initialized) {
            await firstValueFrom(this.api.getApiPTPGetSteps()).then(data => {
                this._steps = data.sort(function (s1, s2) {
                    // ascending
                    return s1.Order - s2.Order;
                });

                this._initialized = true;
                return this._steps;
            });
        }

        return this._steps;
    };

    constructor(private api: PerFormaAPIService) {}
}
